(function ($, Drupal, drupalSettings, cookies) {
  'use strict';

  Theme.dataLayer = function (common, options) {
    // Héritage
    this.common = common;

    // Éléments
    this.elements = {
      html: $('html'),
      body: $('body'),
      window: $(window),
      breadcrumb: $('.nav--breadcrumb'),
      cardArticle: $('.card--article'),
      cardRealization: $('.card--realization'),
      blockStorelocator: $('.block-storelocatormaps'),
      cardAgency: '.card--agency',
      markerAgency: '.leaflet-marker-icon:not(".marker-cluster-small")',
      btnOurInstallers: $('a.our-installers'),
      socialFooter: $('.social-media--wrapper'),
      headerNav: $('.header-nav'),
      footerNav: $('.footer-page'),
    };
  };

  Theme.dataLayer.prototype = {
    init: function () {
      this.dataLayerPageView();
      this.dataLayerArticleClick();
      this.dataLayerAchievementClick();
      this.dataLayerAgencyClick();
      this.dataLayerStoreLocatorClick();
      this.dataLayerSocialClick();
      this.dataLayerPhoneClick();
      this.dataLayerClick();
      this.submissionForms();
    },

    load: function () {
      //console.log('load');
    },
    autoload: function (options) {
      //console.log('autoload');
    },

    /**
     * Event name : page_view
     */
    dataLayerPageView: function () {
      if (this.elements.breadcrumb.length) {
        const data = {
          'event': 'page_view',
        };
        const bodyElement = document.querySelector('.nav--breadcrumb');
        let countChapter = Number(bodyElement.dataset.countChapter) + 1;

        if (bodyElement.dataset.language) {
          data.website_country = bodyElement.dataset.language;
        }
        if (bodyElement.dataset.country) {
          data.website_language = bodyElement.dataset.country;
        }
        if (bodyElement.dataset.pageType) {
          data.page_type = bodyElement.dataset.pageType;
        }
        for (let count = 1; count < countChapter; count++) {
          data['page_chapter_' + count] = bodyElement.dataset['pageChapter' + count];
        }
        if (bodyElement.dataset.pagename) {
          data.page_name = bodyElement.dataset.pagename;
        }

        this.common.setDataLayerEvent('Event "page_view"', '-- With success', data);
      }
      if (drupalSettings.path.isFront) {
        const data = {
          'event': 'page_view',
          'website_country': 'fr',
          'website_language': 'FR',
          'page_type': 'home',
          'page_name': _.snakeCase('Votre indépendance énergétique avec OÏKA'),
        };

        this.common.setDataLayerEvent('Event "page_view"', '-- With success', data);
      }
    },

    /**
     * Event name : article_click
     */
    dataLayerArticleClick: function () {
      var self = this;

      if (self.elements.cardArticle.length) {
        self.elements.cardArticle.on('click', function (e) {
          //e.preventDefault();
          const data = {
            'event': 'article_click',
            'article_name': $(this).find('.article--title span').text().trim(),
          };
          self.common.setDataLayerEvent('Event "article_click"', '-- With success', data);
        });
      }
    },

    /**
     * Event name : achievement_click
     */
    dataLayerAchievementClick: function () {
      var self = this;

      if (self.elements.cardRealization.length) {
        self.elements.cardRealization.on('click', function (e) {
          //e.preventDefault();
          const data = {
            'event': 'achievement_click',
            'achievement_name': $(this).find('.realization--title span').text().trim(),
          };
          self.common.setDataLayerEvent('Event "achievement_name"', '-- With success', data);
        });
      }
    },

    /**
     * Event name : agency_click
     */
    dataLayerAgencyClick: function () {
      var self = this;

      if (self.elements.blockStorelocator.length) {
        /* Agency click to Marker */
        self.elements.body.on('click', self.elements.markerAgency, function (e) {
          //e.preventDefault();
          const data = {
            'event': 'agency_click',
            'agency_name': $(this).attr('title').trim(),
          };
          self.common.setDataLayerEvent('Event "agency_click"', '-- With success', data);
        });

        /* Agency click to Card */
        self.elements.body.on('click', self.elements.cardAgency + ' .item--header', function (e) {
          //e.preventDefault();
          const data = {
            'event': 'agency_click',
            'agency_name': $(this).find('.title').text().trim(),
          };
          self.common.setDataLayerEvent('Event "view_search_results"', '-- With success', data);
        });
      }
    },

    /**
     * Event name : store_locator_click
     */
    dataLayerStoreLocatorClick: function () {
      var self = this;

      if (self.elements.btnOurInstallers.length) {
        self.elements.btnOurInstallers.on('click', function (e) {
          //e.preventDefault();
          const data = {
            'event': 'store_locator_click',
          };
          self.common.setDataLayerEvent('Event "store_locator_click"', '-- With success', data);
        });
      }
    },

    /**
     * Event name : social_click
     */
    dataLayerSocialClick: function () {
      var self = this;

      if (self.elements.socialFooter.length) {
        self.elements.socialFooter.find('.icon').on('click', function (e) {
          //e.preventDefault();
          const data = {
            'event': 'social_click',
            'social_media_name': $(this).data('social-name').trim(),
          };
          self.common.setDataLayerEvent('Event "social_click"', '-- With success', data);
        });
      }
    },

    /**
     * Event name : phone_click
     */
    dataLayerPhoneClick: function () {
      var self = this;

      $('a[href^=\'tel:\']').on('click', function (e) {
        //e.preventDefault();
        const data = {
          'event': 'phone_click',
          'phone_number': $(this).text().trim(),
        };
        self.common.setDataLayerEvent('Event "phone_click"', '-- With success', data);
      });
    },

    /**
     * Event name : header_click, lead_click, cta_click
     */
    dataLayerClick: function () {
      var self = this;

      // Event name : "header_click"
      self.elements.headerNav.find('a:not(.btn)').on('click', function (e) {
        //e.preventDefault();
        const data = {
          'event': 'header_click',
          'cta_name': $(this).text().trim(),
        };
        self.common.setDataLayerEvent('Event "header_click"', '-- With success', data);
      });

      // Event name : "footer_click"
      self.elements.footerNav.find('a:not(.btn, .social, .our-installers)').on('click', function (e) {
        //e.preventDefault();
        const data = {
          'event': 'footer_click',
          'cta_name': $(this).text().trim(),
        };
        self.common.setDataLayerEvent('Event "footer_click"', '-- With success', data);
      });

      // Event name : "lead_click" et "cta_click"
      self.elements.body.find('a:is(.btn)').on('click', function (e) {
        //e.preventDefault();

        // Lead click
        if ($(this).is('.icon-devis')) {
          const data = {
            'event': 'lead_click',
            'cta_name': $(this).text().trim(),
            'click_localisation': $(this).closest('.section').attr('data-section'),
          };
          self.common.setDataLayerEvent('Event "lead_click"', '-- With success', data);
        } else {
          // CTA click
          const data = {
            'event': 'cta_click',
            'cta_name': $(this).text().trim(),
          };
          self.common.setDataLayerEvent('Event "cta_click"', '-- With success', data);
        }
      });
    },

    /**
     * Event name : submission_forms
     */
    submissionForms: function () {
      var self = this;

      window.addEventListener('load', function () {
        if (drupalSettings.formSubmissionValues) {
          if (drupalSettings.formSubmissionName == 'contact') {
            const data = {
              'event': 'contact_form',
              'contact_reason': drupalSettings.formSubmissionValues.wish,
              'zip_code': drupalSettings.formSubmissionValues.zipcode,
              'recall': drupalSettings.formSubmissionValues.recall,
              'hashed_emaill_md5': drupalSettings.formSubmissionEmailMD5,
              'hashed_email_sha256': drupalSettings.formSubmissionEmailSHA256,
              'hashed_email': drupalSettings.formSubmissionEmailSHA256,
            };
            self.common.setDataLayerEvent('Event "contact_form"', '-- With success', data);
          }
          if (drupalSettings.formSubmissionName == 'quotation') {
            const data = {
              'event': 'generate_lead',
              'profil': drupalSettings.formSubmissionValues.type,
              'product_name': drupalSettings.formSubmissionValues.produit,
              'hashed_emaill_md5': drupalSettings.formSubmissionEmailMD5,
              'hashed_email_sha256': drupalSettings.formSubmissionEmailSHA256,
              'hashed_email': drupalSettings.formSubmissionEmailSHA256,
            };
            self.common.setDataLayerEvent('Event "generate_lead"', '-- With success', data);
          }
          
          if (drupalSettings.formSubmissionName == 'landing_page') {
            const data = {
              'event': 'generate_lead_lp',
              //'profil': drupalSettings.formSubmissionValues.type,
              //'product_name': drupalSettings.formSubmissionValues.produit,
              'hashed_emaill_md5': drupalSettings.formSubmissionEmailMD5,
              'hashed_email_sha256': drupalSettings.formSubmissionEmailSHA256,
              'hashed_email': drupalSettings.formSubmissionEmailSHA256,
            };
            self.common.setDataLayerEvent('Event "generate_lead_lp"', '-- With success', data);
          }
        }
      });
    },

  };
})(jQuery, Drupal, drupalSettings, window.Cookies);
